import React, { useState } from 'react';
import styles from './DepositPackageItem.module.scss';
import { currencyFormat } from '../../../../utils/currencyFormat';
import StatusDeposit from '../StatusDeposit/StatusDeposit';
import clsx from 'clsx';
import { imgPath } from '../../../../utils/imgPath';
import { Close, PublishedWithChangesOutlined } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { purple } from '@mui/material/colors';
const DepositPackageItem = ({ icon, price, name, status, form, nameForm, admin }) => {
  if (form) {
    form.watch(nameForm);
  }
  const [showMenuStatus, setShowMenuStatus] = useState(false);
  return (
    <>
      <div className={clsx(styles.wrap)}>
        <div className={clsx(styles.content)}>
          {' '}
          <img src={imgPath(icon)} alt="" className={clsx(styles.icon)} />
          <div className={clsx(styles.box)}>
            <div className={clsx(styles.name)}>{name}</div>
            <div className={clsx(styles.price)}>{currencyFormat(price)}</div>
          </div>
        </div>
        {admin ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <StatusDeposit status={status} noTooltip={admin} />
            <IconButton
              disableRipple
              size="small"
              sx={{ color: purple[400], position: 'relative' }}
              onClick={() => {
                setShowMenuStatus(!showMenuStatus);
              }}>
              {showMenuStatus ? <Close /> : <PublishedWithChangesOutlined />}

              <div className={clsx(styles.menuStatus, showMenuStatus && styles.menuStatusShow)}>
                <StatusDeposit
                  status={'success'}
                  noTooltip={true}
                  onClick={() => {
                    form.setValue(nameForm, 'success');
                  }}
                />
                <StatusDeposit
                  status={'paid'}
                  noTooltip={true}
                  onClick={() => {
                    form.setValue(nameForm, 'paid');
                  }}
                />
                <StatusDeposit
                  status={'not-available'}
                  noTooltip={true}
                  onClick={() => {
                    form.setValue(nameForm, 'not-available');
                  }}
                />
                <StatusDeposit
                  status={'incorrect'}
                  noTooltip={true}
                  onClick={() => {
                    form.setValue(nameForm, 'incorrect');
                  }}
                />
              </div>
            </IconButton>
          </Box>
        ) : (
          <StatusDeposit status={status} />
        )}
      </div>
    </>
  );
};

export default DepositPackageItem;
